import { render, staticRenderFns } from "./MyStore.vue?vue&type=template&id=74fb9870&scoped=true"
import script from "./MyStore.vue?vue&type=script&lang=js"
export * from "./MyStore.vue?vue&type=script&lang=js"
import style0 from "./MyStore.vue?vue&type=style&index=0&id=74fb9870&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74fb9870",
  null
  
)

export default component.exports